import React from 'react';

const Pagamenti = () => {
  return (
    <svg
      version="1.1"
      id="pagamenti_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 80 80"
      style="enable-background:new 0 0 80 80;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 4,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 22.9256,
        verticalAlign: 'middle',
      }}
    >
      <path d="M61.06,34.31c2.89,0,5.24,2.34,5.24,5.24c0,2.89-2.34,5.24-5.24,5.24c-2.89,0-5.24-2.35-5.24-5.24 C55.82,36.66,58.16,34.31,61.06,34.31L61.06,34.31z" />
      <path d="M9.23,5h62.31c3.73,0,6.78,3.05,6.78,6.78v55.53c0,3.73-3.05,6.78-6.78,6.78H9.23c-3.73,0-6.78-3.05-6.78-6.78 V11.78C2.45,8.05,5.5,5,9.23,5L9.23,5z" />
      <line x1="51.99" y1="27.01" x2="78.32" y2="27.01" />
      <line x1="78.32" y1="52.09" x2="51.99" y2="52.09" />
      <path d="M51.99,52.09c-2.14,0-3.9-1.76-3.9-3.9" />
      <line x1="48.08" y1="48.18" x2="48.08" y2="30.91" />
      <path d="M48.08,30.91c0-2.15,1.76-3.9,3.9-3.9" />
    </svg>
  );
};

export default Pagamenti;
